<template>
    <div style="padding:12px">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-button type="primary" size="medium" @click="submitOrderHandler()">提交订单</el-button>
        </div>
        <div class="body" :style="`height: ${windowHeight-180}px;`">
            <div class="main-panel">
                <el-form label-width="140px" class="form--display">
                    <el-form-item label="学校名称">
                        {{detail.name}}
                    </el-form-item>
                    <el-form-item label="corpid">
                        {{detail.corpId}}
                    </el-form-item>
                    <el-form-item label="家校类型">
                        {{detail.isExternalContact == 2 ? '新家校' : '老家校'}}
                    </el-form-item>
                    <!-- <el-form-item label="购买推荐数">
                        {{userCount.recommendCount}}
                    </el-form-item> -->
                </el-form>
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="授权账号数" prop="baseCount">
                        <el-input-number v-model="formData.baseCount" :min="1" :max="100000"
                                         step-strictly></el-input-number>
                    </el-form-item>
                    <el-form-item label="月数" prop="durationMonths">
                        <el-select v-model="formData.durationMonths" placeholder="请选择">
                            <el-option label="1个月" :value="1"></el-option>
                            <el-option label="12个月" :value="12"></el-option>
                            <el-option label="24个月" :value="24"></el-option>
                            <el-option label="36个月" :value="36"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer.vue';
    import baseMixin from '@/mixins/baseMixin';
    import mixin from "@/mixins/windowResize";
    import {
        querySchoolDetail,
        createOrder
    } from '@/api/schoolManage';
    import {isShowByPermission} from '@/utils/utils';

    export default {
        name: 'schoolDetail',
        components: {ImagePreviewer},
        filters: {
            timeFormat(time) {
                return time ? time.substring(0, 19) : ''
            }
        },
        mixins: [baseMixin, mixin],

        data() {
            return {
                schoolId: this.$route.query.schoolId,
                detail: {},
                userCount: {},
                formData: {
                    baseCount: 1,
                    durationMonths: 12,
                },
                rules: {
                    baseCount: [
                        {required: true, trigger: 'blur', message: '请输入授权账号数'},
                    ],
                    durationMonths: [
                        {required: true, trigger: 'blur', message: '请输入月数'},
                    ],
                }
            }
        },
        created() {
            querySchoolDetail({
                schoolId: this.schoolId
            })
                .then(data => {
                    this.detail = data;
                });
        },
        methods: {
            isShowByPermission,
            submitOrderHandler() {
                this.$refs.form.validate(isValid => {
                    if(isValid) {
                        createOrder({
                            baseCount: this.formData.baseCount,
                            durationMonths: this.formData.durationMonths,
                            schoolId: this.schoolId,
                            // corpId: this.detail.corpId
                        })
                            .then(() => {
                                this.$message.success('提交成功');
                                this.$router.go(-1);
                                // window.setTimeout(() => {
                                //     this.$router.replace({
                                //         path: '/main/customService/schoolManage/newOrderList',
                                //         query: {
                                //             schoolId: this.schoolId,
                                //         }
                                //     })
                                // }, 500);
                            })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    .main-panel {
        width: 810px;
        margin: 10px auto;
    }

    .right-panel {
        float: left;
    }

    .title {
        border-left: 4px solid #409EFF;
        padding-left: 12px;
        height: 16px;
        line-height: 16px;

        &:not(:first-of-type) {
            margin-top: 40px;
        }
    }

    .top {
        border-bottom: 1px solid #e7eaec;
        padding-bottom: 10px;
    }

    .body {
        overflow: auto;
        padding-top: 10px;
    }

    .left-panel-btn-item {
        margin: 10px 0;
    }

    .detail-item {
        margin: 20px 0;

        & > * {
            display: inline-block;
        }
    }

    .detail-item__title {
        width: 200px;
    }

    .detail-item__value {
        padding-left: 16px;
        width: 500px;
        color: #909399;

    }

    .logo-list {
        margin-top: 20px;
        background: #ccc;
        padding: 10px;

        & > * {
            @include middleIB;
        }

        .logo-item {
            text-align: center;
            margin-right: 10px;
            font-size: 14px;

            img {
                height: 100px;
            }
        }
    }

    @media screen and (max-width: 1600px) {
        .left-panel {
            margin-left: 100px;
        }
    }

    @media screen and (max-width: 1450px) {
        .left-panel {
            margin-left: 40px;
            width: 200px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolGrant.vue